var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGdxy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #3e4244;\n      }\n\n      .cls-2, .cls-3 {\n        opacity: .8;\n      }\n\n      .cls-3 {\n        fill: #434749;\n      }\n\n      .cls-4 {\n        fill: #a06e00;\n      }\n\n      .cls-5 {\n        fill: #e0b12b;\n      }\n\n      .cls-6 {\n        fill: #777d7f;\n      }\n\n      .cls-7 {\n        fill: #fff4b3;\n      }\n\n      .cls-8 {\n        fill: #798184;\n      }\n\n      .cls-9 {\n        fill: #4b4f51;\n      }\n\n      .cls-10 {\n        fill: #f9d953;\n      }\n\n      .cls-11 {\n        fill: #99a0a3;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_\\u9577\\u65B9\\u5F62_",
    "data-name": "&lt;\\u9577\\u65B9\\u5F62&gt;",
    className: "cls-1",
    width: 28,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_30_\\u91D1\\u9271\\u682A\\u30AB\\u30D0\\u30B3\\u6BCE\\u9031\\u5206\\u914D",
    "data-name": "30_\\u91D1\\u9271\\u682A\\u30AB\\u30D0\\u30B3\\u6BCE\\u9031\\u5206\\u914D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_30_\\u91D1\\u9271\\u682A\\u30AB\\u30D0\\u30B3\\u6BCE\\u9031\\u5206\\u914D_2xPNG_",
    "data-name": "30_\\u91D1\\u9271\\u682A\\u30AB\\u30D0\\u30B3\\u6BCE\\u9031\\u5206\\u914D\\uFF082xPNG\\uFF09"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30C8\\u30ED\\u30C3\\u30B3",
    "data-name": "\\u30C8\\u30ED\\u30C3\\u30B3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u91D1",
    "data-name": "\\u91D1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "15.704 5.184 18.533 4.638 21.258 8.782 16.277 8.914 15.704 5.184"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "21.545 9.134 17.82 9.354 18.736 6.042 18.521 4.622 19.5 6.075 21.545 9.134"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M18.171,9.002l-2.133.132.255-1.233,2.448-1.857c-.155.377-.57,2.957-.57,2.957Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u91D1-2",
    "data-name": "\\u91D1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "5.406 8.914 6.142 6.785 7.745 6.327 8.191 5.148 12.457 4.094 14.128 9.244 5.406 8.914"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "6.139 6.789 9.974 5.603 8.35 7.528 6.139 6.789"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "8.303 9.442 8.35 7.528 9.95 5.613 12.345 4.063 14.319 9.442 8.303 9.442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u91D1-3",
    "data-name": "\\u91D1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "9.508 8.782 10.642 6.075 11.597 5.415 12.481 3.5 15.895 4.358 17.948 8.716 9.508 8.782"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "10.022 7.462 11.597 7.528 12.6 6.339 15.656 5.613 15.901 4.357 18.222 8.96 9.258 9.442 10.022 7.462"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "15.665 5.61 12.582 8.704 12.588 6.333 15.665 5.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "10.099 7.384 11.615 7.518 11.136 9.751 8.939 9.729 10.099 7.384"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u672C\\u4F53",
    "data-name": "\\u672C\\u4F53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "19.315 19.441 7.285 19.441 4.415 10.295 22.185 10.295 19.315 19.441"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 12.516,
    y: 10.687,
    width: 1.699,
    height: 8.493
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "8.862 19.441 7.285 19.441 4.415 10.295 6.113 10.295 8.862 19.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.743 19.441 19.32 19.441 22.19 10.295 20.491 10.295 17.743 19.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "19.923 11.867 18.017 18.641 17.396 18.641 19.368 11.867 19.923 11.867"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u4E0B\\u90E8\\u30D1\\u30FC\\u30C4",
    "data-name": "\\u4E0B\\u90E8\\u30D1\\u30FC\\u30C4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 5.329,
    y: 18.788,
    width: 15.941,
    height: 1.829
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 5.329,
    y: 18.788,
    width: 15.941,
    height: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u8ECA\\u8F2A",
    "data-name": "\\u8ECA\\u8F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 8.596,
    cy: 20.487,
    r: 2.613
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 8.596,
    cy: 20.487,
    r: 1.908
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 8.596,
    cy: 20.487,
    r: 1.176
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 8.596,
    cy: 20.487,
    r: 0.732
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u8ECA\\u8F2A-2",
    "data-name": "\\u8ECA\\u8F2A"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 18.004,
    cy: 20.487,
    r: 2.613
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 18.004,
    cy: 20.487,
    r: 1.908
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 18.004,
    cy: 20.487,
    r: 1.176
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 18.004,
    cy: 20.487,
    r: 0.732
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u4E0A\\u90E8\\u30D1\\u30FC\\u30C4",
    "data-name": "\\u4E0A\\u90E8\\u30D1\\u30FC\\u30C4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3.5,
    y: 8.857,
    width: 19.6,
    height: 2.352
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.697 11.871 4.915 11.871 4.706 11.221 21.899 11.221 21.697 11.871"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 3.5,
    y: 8.857,
    width: 19.6,
    height: 1.568
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30C9\\u30EB\\u888B",
    "data-name": "\\u30C9\\u30EB\\u888B"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.5,20.54c0,2.187-2.068,3.96-4.62,3.96-.935,0-1.806-.238-2.534-.648-1.257-.708-2.086-1.927-2.086-3.312,0-2.187,4.62-5.998,4.62-5.998,0,0,.738.609,1.625,1.48,1.331,1.308,2.995,3.206,2.995,4.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.5,20.54c0,2.187-2.068,3.96-4.62,3.96-.935,0-1.553-.106-2.28-.516.321.171.976.205,1.763.186,1.783-.041,3.534-1.682,3.492-3.733-.03-1.47-.899-3.009-1.711-4.298-.108-.019-.115-.058-.122-.097.161-.017.322-.023.483-.021,1.331,1.308,2.995,3.206,2.995,4.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18.134,15.917l-1.692-2.169s.326-.127.761-.069c.431.057.338.224.745.253.384.027.455-.431.902-.431s.666.431,1.051.431.497-.402.943-.431c.414-.027.503.505,1.01.472.257-.017.415-.256.695-.34.495-.149.818.032.794.033l-1.659,2.262-3.55-.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.688,15.933l1.655-2.266c.033-.015-.372-.158-.741-.046l-1.494,2.312h.579Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.774,
    y: 15.791,
    width: 4.212,
    height: 0.544,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.802,22.67c-.397,0-.742-.061-1.036-.183-.294-.122-.523-.303-.687-.543s-.251-.535-.259-.886h.988c.013.167.063.306.15.418.086.112.202.196.346.251.144.056.307.083.489.083s.34-.026.474-.078c.134-.052.239-.126.314-.222.075-.095.113-.206.113-.333,0-.113-.034-.208-.101-.285-.068-.077-.165-.143-.291-.198-.126-.055-.28-.104-.462-.147l-.545-.137c-.419-.102-.747-.263-.984-.481-.237-.219-.356-.508-.356-.867,0-.3.08-.562.241-.786.161-.224.381-.398.662-.523.28-.124.6-.186.959-.186.366,0,.685.063.958.188.273.125.486.3.639.523.153.223.232.48.236.771h-.981c-.018-.2-.102-.354-.254-.463-.152-.109-.354-.163-.607-.163-.171,0-.317.024-.439.073-.122.049-.215.117-.278.203s-.095.185-.095.296c0,.122.037.224.11.305.073.081.171.147.293.196.122.05.252.092.389.125l.449.11c.208.047.402.11.582.19.18.08.337.178.472.295.135.117.24.255.314.415.074.16.111.344.111.553,0,.3-.075.561-.226.784-.151.223-.369.396-.655.518-.286.122-.63.183-1.031.183ZM19.599,23.266v-6.301h.399v6.301h-.399Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdxy);
export default __webpack_public_path__ + "static/media/GDXY.5272d5d66d2ee3a503da48f7d749a398.svg";
export { ForwardRef as ReactComponent };